module.exports = __webpack_public_path__ + "media/images/menu_icon-f8336b068ba751516b713c8042b97ba5.gif";